export enum ErrorCodeEnum {
    None = 9999,
    Default = 0,
    ResourceProviderUnreachable = 1,
    ConnectionClosed = 2,
    NativeClient = 3,
    Custom = 4,
    Unauthorized = 401,
    PaymentRequired = 402,
    Unauthenticated = 403,
    NotFound = 404,
    TooManyRequests = 429,
    ResourceNotFound = 503
}
